import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import { ActivationEnd, Event, NavigationEnd, Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class RouterEventService {
  private routeChangedSource: BehaviorSubject<any> =
    new BehaviorSubject<string>(this.router.url);
  private routeParamIdChangedSource: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);
  public routeChanged$: Observable<string> =
    this.routeChangedSource.asObservable();
  public routeParamIdChanged$: Observable<number> =
    this.routeParamIdChangedSource.asObservable();

  constructor(private router: Router) {
    this.listenForAvailableParamIdChanges().subscribe((paramId: number) => {
      this.routeParamIdChangedSource.next(paramId);
    });
  }

  public updateRouteChangedSource(value: any): void {
    this.routeChangedSource.next(value);
  }

  public listenForRouteChanges(): Observable<NavigationEnd> {
    return this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
    );
  }

  private listenForAvailableParamIdChanges(): Observable<any> {
    return this.router.events.pipe(
      filter((event: Event) => event instanceof ActivationEnd),
      map((event: Event) => (event as ActivationEnd)!.snapshot!.params.id),
      filter((id: number) => !isNaN(id)),
    );
  }
}
